import React, { ChangeEvent } from 'react';
import SVGImage from '../layout/SVGImage';

interface ForecastMultiSelectCheckboxProps {
  text: string;
  className?: string;
  isChecked?: boolean;
  onChangeIsChecked?: (isChecked: boolean) => void;
  testId?: string;
}

const ForecastMultiSelectCheckbox: React.FC<
  ForecastMultiSelectCheckboxProps
> = ({ text, className, isChecked, onChangeIsChecked, testId }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChangeIsChecked) onChangeIsChecked?.(e.target.checked);
  };
  const bg = isChecked ? 'bg-white' : 'bg-[#E8EEEE]';
  const border = isChecked ? 'border-[1.5px] border-teal-main' : 'border-none';

  return (
    <label className={`${className} relative flex items-center`}>
      <input
        data-testid={testId}
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className={`h-5 w-5 appearance-none rounded-[5px] ${border} ${bg}`}
      />
      {isChecked && (
        <SVGImage
          className="absolute translate-x-[3px]"
          name={'checkmark'}
        ></SVGImage>
      )}
      <span className="ml-[10px]">{text}</span>
    </label>
  );
};

export default ForecastMultiSelectCheckbox;
